import { useContext, useEffect, useRef, useState } from "react";
import activoContext from "../../context/activoContex/activoContex";
import nivel1Context from "../../context/nivel1Context/nivel1Context";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDoubleDown, faAngleDoubleUp, faSortDown, faSortUp } from "@fortawesome/free-solid-svg-icons";

import './ContextualMenuCalendar.css';
import nivel2Context from "../../context/nivel2Context/nivel2Context";
import nivel3Context from "../../context/nivel3Context/nivel3Context";
import nivel4Context from "../../context/nivel4Context/nivel4Context";
import nivel5Context from "../../context/nivel5Context/nivel5Context";

const ContextualMenuCalendar = ({showContextualMenu, setShowContextualMenu, handleChangeDeliveryDate}) => {

    const ref = useRef();

    const [pos,setPos] = useState({x: -9999, y: -9999});

    const handleModDeliveryDate = () => {
        if(showContextualMenu.nodeId.state != 'FINALIZADA'){
            handleChangeDeliveryDate(showContextualMenu.nodeId);
            setShowContextualMenu(null);
        }
    }
    
    const handleDelete = () => {

    }
	
    useEffect(() => {
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                setShowContextualMenu(null);
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(()=>{
        const menu = ref.current;
        if(!menu) return;

        const { innerHeight, innerWidth } = window;
        const rect = menu.getBoundingClientRect();

        let newX = showContextualMenu.x;
        let newY = showContextualMenu.y;

        if(newY + rect.height > innerHeight){
            newY = newY - rect.height;
        }

        setPos({x: newX, y: newY});
    },[showContextualMenu]);

   return <div ref={ref} className='contextualMenuCalendarContainer' style={{ top: pos.y, left: pos.x }}>
        {<h6 className={showContextualMenu.nodeId.state != 'FINALIZADA' ? '' : 'unable'} onClick={handleModDeliveryDate}>CAMBIAR FECHA</h6>} 
    </div>

}

export default ContextualMenuCalendar;